import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { getPurchasedCustomPrintCartItem } from '../../../../../../../../services/checkout/redux/helpers';
import { getCheckoutCart } from '../../../../../../../../services/checkout/redux/checkoutSelectors';
import {
  cartItemUpdate,
  togglePurchasedCustomPrintCartItem,
} from '../../../../../../../../services/checkout/redux/checkoutActions';
import { openModal as openModalAction } from '../../../../../../../../actions/modal-actions';
import CustomPrintOption from './CustomPrintOption';

const propTypes = {
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  prepaidCustomPrints: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      quantity: PropTypes.number,
    }),
  ).isRequired,
  cart: PropTypes.array.isRequired,
  onCartItemUpdate: PropTypes.func.isRequired,
  onPurchasedCustomPrintToggle: PropTypes.func.isRequired,
  onPurchasedDigitalDownloadToggle: PropTypes.func.isRequired,
  onCheckout: PropTypes.func.isRequired,
  optionProps: PropTypes.object,
  className: PropTypes.string,
  activeIdentity: PropTypes.shape({
    id: PropTypes.string,
  }),
  albumMembershipPhoto: PropTypes.shape({
    id: PropTypes.string,
  }),
  isAllPhotos: PropTypes.bool,
};

const CustomPrintOptionList = ({
  albumMembershipGroup,
  prepaidCustomPrints,
  cart,
  onCartItemUpdate,
  onPurchasedCustomPrintToggle,
  onCheckout,
  optionProps,
  className,
  activeIdentity,
  albumMembershipPhoto,
  isAllPhotos,
}) => {
  const classes = classNames({
    'album-print-package-option-list': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {prepaidCustomPrints.map(purchasedCustomPrint => {
        const {
          quantity,
          album_custom_print: albumCustomPrint,
        } = purchasedCustomPrint;

        return (
          <CustomPrintOption
            key={purchasedCustomPrint.id}
            albumMembershipPhoto={albumMembershipPhoto}
            purchasedCustomPrint={purchasedCustomPrint}
            albumMembershipGroup={albumMembershipGroup}
            cartItem={getPurchasedCustomPrintCartItem(cart, {
              purchasedCustomPrintId: purchasedCustomPrint.id,
            })}
            onUpdate={onCartItemUpdate}
            onCheckout={onCheckout}
            isAllPhotos={isAllPhotos}
            identity={activeIdentity}
            onPurchasedCustomPrintToggle={configuration => {
              onPurchasedCustomPrintToggle({
                purchasedCustomPrint,
                configuration,
                albumMembershipGroup,
                quantity,
                shipping: albumCustomPrint.shipping_enabled,
                identity: activeIdentity,
                isAllPhotos,
              });
            }}
            {...(optionProps ?? {})}
          />
        );
      })}
    </div>
  );
};

CustomPrintOptionList.propTypes = propTypes;

const mapStateToProps = state => ({
  cart: getCheckoutCart(state),
  activeIdentity: state.checkout.activeIdentity,
});

const mapDispatchToProps = {
  openModal: openModalAction,
  onCartItemUpdate: cartItemUpdate,
  onPurchasedCustomPrintToggle: togglePurchasedCustomPrintCartItem,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomPrintOptionList);
